import { UIComponentProps, UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler } from '../uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../uicomponentview';
import { GridTabViewImpl } from './gridtabview';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { GridTabCSSStyleImpl } from './gridtabcss';
import { GridTabViewModelImpl } from './gridtabviewmodel';

export interface GridTabComponentProps extends UIComponentProps
{
    id: string;
    genericTabViewModel: GridTabViewModelImpl;
    initialTab: string;
    onTabSelected(title: string): void;
}

export interface GridTabComponentState extends UIComponentState
{
    selectedTabContent: JSX.Element | boolean;
    selectedTabTitle: string;
}

export interface GridTabComponentHandler extends UIComponentHandler
{
    onTabSelected(title: string): void;
}

export class GridTabComponent extends UIComponentImpl<GridTabComponentProps,
GridTabComponentState, UIDataModel> implements GridTabComponentHandler
{
    constructor(props: GridTabComponentProps)
    {
        super(props);

        let tab = this.props.genericTabViewModel.getTab(props.initialTab);

        console.log("---initial tab: " + props.initialTab +", tab: " + tab);
        this.state = {selectedTabTitle: props.initialTab , selectedTabContent: tab !== undefined ? tab.getTabView() : false};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new GridTabViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new GridTabCSSStyleImpl(applicationContext);
    }

    clearData()
    {
        this.state = {selectedTabTitle: "" , selectedTabContent: false};
    }

    onTabSelected(title: string): void 
    {
        console.log("----onTabSelected: " + title);
        this.props.onTabSelected(title);
        let tab = this.props.genericTabViewModel.getTab(title);

        console.log("----tab: " + tab);
        this.setState({selectedTabTitle: title , 
            selectedTabContent: tab !== undefined ? tab.getTabView() : false}, () =>
            {
                let showmore = document.getElementById(this.props.id);
                if(showmore !== null)
                {
                    let offsetTop = showmore.getBoundingClientRect().top + window.scrollY;
                    console.log("------offsetTop: " + offsetTop);
                    window.scroll(0, (offsetTop - 50));
                }
            });
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/gridtabs/gridtabcomponent.tsx